export default __webpack_public_path__ + "static/media/home2XXS.0e9d3886.webp";